import assert from 'assert';
import { useRouter } from 'next/router';
import { useSessionAppointmentId } from './useSessionAppointmentId';
import useUserAppointments from './useUserAppointments';

export function useSessionAppointment(audit?: boolean) {
  const { query } = useRouter();
  const appt_id = useSessionAppointmentId(!audit);

  const { userAppointments, refetchUserAppointments } = useUserAppointments('USER_APPOINTMENTS', {
    appt_id,
    team: !!query.team
  });

  assert(userAppointments, 'userAppointments is required');

  return {
    appointment: {
      ...userAppointments?.payload?.[0],
      read_only: userAppointments?.payload?.[0]?.read_only || !!userAppointments?.payload?.[0]?.audit_appt_id || false
    },
    refetchAppointment: refetchUserAppointments
  };
}
